































































































































































































































































































































































import { Component, Vue, Watch, Ref, Mixins } from "vue-property-decorator";
import NavRiwayat from "@/components/NavRiwayat.vue";
import CardSuratKonsul from "@/components/pemeriksaan/konsulRujukan/CardSuratKonsul.vue";
import CardSuratRujukanRalan from "@/components/pemeriksaan/konsulRujukan/CardSuratRujukanRalan.vue";
import CardRujukanHiv from "@/components/pemeriksaan/konsulRujukan/CardRujukanHiv.vue";
import CardRujukanDotsHiv from "@/components/pemeriksaan/tabs/rujukan/CardRujukanDotsHiv.vue";
import CardSuratRujukanBalikHaji from "@/components/pemeriksaan/tabs/rujukan/CardSuratRujukanBalikHaji.vue";
import CardSuratRujukanRanap from "@/components/pemeriksaan/konsulRujukan/CardSuratRujukanRanap.vue";
import CardSuratJawabanRujukan from "@/components/pemeriksaan/konsulRujukan/CardSuratJawabanRujukan.vue";
import CardOrderPenunjang from "@/components/pemeriksaan/penunjang/CardOrderPenunjang.vue";
import CardPemeriksaan from "../components/CardPemeriksaan.vue";
import PasienFlyingBar from "@/components/PasienFlyingBar.vue";
import {
  RALAN_FORM_INDEX,
  IGD_FORM_INDEX,
  PEMERIKSAAN_RINGKAS_FORM_INDEX,
  PEMERIKSAAN_GIZI_FORM_INDEX,
  PEMERIKSAAN_REKAM_MEDIS_FORM_INDEX,
  FormIndexEntry
} from "@/utils/ralanFormRegistry";
import DataResume from "../services/DataResume";
import { storeSoap } from "@/store/modules/soap";
import { storePasien } from "@/store/modules/pasien";
import { userModule } from "@/store/modules/user";
import TabResepObat from "@/components/pemeriksaan/TabResepObat.vue";
import { appModule } from "@/store/modules/app";
import CardSnackBar from "@/components/modal/CardSnackBar.vue";
import { storeResume } from "@/store/modules/resume";
import CardAssesmenV2 from "@/components/pemeriksaan/assesmen/CardAssesmenV2.vue";
import { storeDokter } from "@/store/modules/dokter";
import { storeAssesmenRalan } from "@/store/modules/asesmenralan";
import { storeKonsul } from "@/store/modules/konsul";
import ModalKonfirmasi from "@/components/modal/KonfirmasiLogout.vue";
import DataAsesmenRalan from "@/services/DataAsesmenRalan";
import CardSuketV2 from "@/components/pemeriksaan/resumeSuketV2/CardSuket.vue";
import { storeCatatanEdukasi } from "@/store/modules/catatanedukasi";
import * as regHf from "@/services/registerHf";
import RegisterKunjungan, {
  IfcRegister
} from "@/store/modules/RegisterKunjungan";
import storePanggilanLayanan from "@/store/modules/new/PanggilanLayanan";
import { storeRiwayat } from "@/store/modules/riwayat";
import RekamMedisIgd from "@/pages/PemeriksaanIgdPage/RekamMedisIgd.vue";
import RekamMedisLabRadiologi from "@/components/pemeriksaan/assesmen/RekamMedisLabRadiologi.vue";
import TabKonsulRanap from "@/components/pemeriksaan/TabKonsulRanap.vue";
import TindakanMedikPoliklinik from "@/components/pemeriksaan/pelayanan/TindakanMedikPoliklinik.vue";
import storeBilling from "@/store/modules/Billing";
import Billing from "@/services/Billing";
import LockingRegister from "@/utility/LockingRegister";
import storeReferensiUnit from "@/store/modules/new/ReferensiUnit";
import storeRefAsesmen from "@/store/modules/new/ReferensiAsesmen";
import moment from "moment";
import DataPenunjang from "@/services/DataPenunjang";
import ModalICareBpjs from "@/components/modal/ModalICareBpjs.vue";
import ListKonsulRujukInternal from "@/components/ListKonsulRujukInternal.vue";
import PemeriksaanReadonlyBanner from "@/components/pemeriksaan/PemeriksaanReadonlyBanner.vue";
import ActingUnitPage from "@/mixins/ActingUnitPage";
import {
  evaluatePemeriksaanReadOnly,
  evaluateVerifikasiLock
} from "@/utility/PemeriksaanReadonly";
import type { ActiveApproval } from "@/utility/PemeriksaanReadonly";
import revisionAccessModule from "@/store/modules/RevisionAccessStore";
import VerifikasiTerpaduDialog from "@/components/verifikasi/VerifikasiTerpaduDialog.vue";
import { scrollTabIntoView } from "@/utils/scrollTabIntoView";

import { resetStorePasienRalan } from "@/utils/resetStorePasien";
import { ambilPrefillSkdp } from "@/utils/titipanPrefillSkdp";
import {
  isHemodialisa,
  isInstalasiGizi,
  isPemeriksaanRingkas,
  isRanap,
  isUnitAdministrasi,
  isUnitRekamMedis
} from "@/utils/unit";

const PEMERIKSAAN_RINGKAS_TOP_TABS: ReadonlyArray<string> = [
  "tab-assesmen",
  "tab-penunjang",
  "tab-konsul",
  "tab-pelayanan"
];

const ADMINISTRASI_TOP_TABS: ReadonlyArray<string> = [
  "tab-persetujuan",
  "tab-suket",
  "tab-pelayanan"
];

@Component({
  components: {
    VerifikasiTerpaduDialog,
    CardSuratKonsul,
    CardSuratRujukanRalan,
    CardSuratRujukanRanap,
    CardSuratJawabanRujukan,
    CardRujukanHiv,
    CardRujukanDotsHiv,
    CardSuratRujukanBalikHaji,
    NavRiwayat,
    CardPemeriksaan,
    ModalKonfirmasi,
    PasienFlyingBar,
    CardOrderPenunjang,
    TabResepObat,
    CardSnackBar,
    CardAssesmenV2,
    CardSuketV2,
    RekamMedisIgd,
    RekamMedisLabRadiologi,
    TabKonsulRanap,
    TindakanMedikPoliklinik,
    ModalICareBpjs,
    ListKonsulRujukInternal,
    PemeriksaanReadonlyBanner
  },
  provide() {
    const self = this as Vue & {
      isReadOnly: boolean;
      isVerifikasiTerkunci: boolean;
    };
    return {
      isReadOnly: () => self.isReadOnly,
      isVerifikasiTerkunci: () => self.isVerifikasiTerkunci
    };
  },
  beforeCreate() {
    userModule.syncActingUnit(this.$route);

    const reg = RegisterKunjungan.getRegister(this.$route.params.register);

    reg.catch(err => {
      if (err.response?.status === 404) {
        this.$router.push("/404");
      }
    });
  },
  beforeRouteLeave(to, from, next) {
    LockingRegister.unlockRegister("klinik");
    resetStorePasienRalan();

    next();
  },
  async beforeRouteUpdate(to, from, next) {
    LockingRegister.unlockRegister("klinik");
    resetStorePasienRalan();

    try {
      await RegisterKunjungan.getRegister(to.params.register);
    } catch (err) {
      const e = err as { response?: { status?: number } };
      if (e?.response?.status === 404) {
        return next("/404");
      }
    }

    const self = this as Vue & {
      register: string;
      rm: string;
      tgl: string;
      callDataStore: () => void;
    };
    self.register = to.params.register;
    self.rm = to.params.rm;
    self.tgl = to.params.tgl;
    self.callDataStore();

    next();
  }
})
export default class Pemeriksaan extends Mixins(ActingUnitPage) {
  @Ref() refModalICare: ModalICareBpjs;

  modalRujukan: boolean;
  modalSpri: boolean;
  ttdRujukan: boolean;
  dataSoap = {};
  btn = "hidden";
  // tab = "tab-soap";
  tab = "tab-konsul";
  // tabs='0'
  respResumes = {};
  register = "";
  rm: string;
  alertOpen = false;
  err: object = {};
  sess_login = this.stateuser;
  copySoap = {
    s: "",
    o: "",
    a: "",
    p: ""
  };
  openRightNavigationDrawer = false;
  fab = false;
  tgl = "";
  openDrawer = true;
  drawer = true;
  clipped = false;
  statusAssesmen = {};
  msgConfirm = "";
  modalOpenKonfirmasi = false;
  statusAsesmen = "0";
  tabKonsul = "konsul-keluar";
  subTabRujukan = "sub-konsul-internal";
  subTabRujukanRanap = "sub-rujukan-ranap";
  cat = "";

  // Universal form-search wiring: PasienFlyingBar -> here -> sub-page deep link.
  deepLink: any = null;
  statusLock = "0";
  showNotifToast = false;
  notifToastMsg = "";
  notifToastTimeout = 10000;

  created() {
    if (this.$route.params.page == "tab-jwbkonsul") {
      this.tab = "tab-konsul";
      this.tabKonsul = "konsul-masuk";
    } else {
      this.tab = this.$route.params.page;
    }

    this.applyQueryDeepLink();

    if (this.topTabTerbatas && !this.topTabTerbatas.includes(this.tab)) {
      this.tab = this.topTabAwal;
    }

    this.register = this.$route.params.register;
    this.rm = this.$route.params.rm;
    this.tgl = this.$route.params.tgl;

    this.callDataStore();
  }
  mounted() {
    this.statusAsesmen = "0";

    if (this.stateuser.unit_id != "01" && !this.isPemeriksaanRingkas) {
      this.alertAsesmenAwalRalan();

      // show iCare Dialog on selected unit
      setTimeout(() => {
        if (
          // ["27", "08", "10", "11", "12", "09", "07"].includes(
          //   this.stateuser.unit_group_id
          // ) &&
          this.currentRegister.asr_n &&
          moment().format("YYYY-MM-DD") ==
            moment(this.currentRegister.tgl, "DD-MM-YYYY").format(
              "YYYY-MM-DD"
            ) &&
          this.currentRegister.dokter?.id == this.stateuser.id
        ) {
          const soapDr = this.statesoapdata.filter(
            it => it.user.id == this.stateuser.id
          );

          if (
            soapDr.length == 0 &&
            (parseInt(this.currentRegister.no) % 2 == 0 ||
              parseInt(this.currentRegister.no) % 3 == 0 ||
              parseInt(this.currentRegister.no) % 5 == 0)
          ) {
            this.refModalICare.open();
          }
        }
      }, 2000);
    }

    if (this.stateuser.unit_group_id == "27") {
      this.alertRegHf();
    }
  }

  get currentRegister() {
    return RegisterKunjungan.register;
  }

  get activeApproval(): ActiveApproval | null {
    const reg = RegisterKunjungan.register;
    const no = reg?.no;
    if (!no) return null;
    const snap = revisionAccessModule.activeByRegister[no];
    if (!snap?.has_active || !snap.active) return null;
    return {
      expiresAt: snap.active.expires_at,
      approvedAt: snap.active.approved_at,
      grantedMinutes: snap.active.granted_minutes
    };
  }

  get readOnlyResult() {
    return evaluatePemeriksaanReadOnly(
      RegisterKunjungan.register,
      new Date(),
      this.activeApproval,
      userModule.unitGate
    );
  }

  get isReadOnly() {
    return this.readOnlyResult.readOnly;
  }

  get verifikasiLockResult() {
    return evaluateVerifikasiLock(
      RegisterKunjungan.register,
      new Date(),
      this.activeApproval
    );
  }

  get isVerifikasiTerkunci() {
    return this.verifikasiLockResult.locked;
  }

  get registerUnitLoaded(): boolean {
    return !!(this.currentRegister && this.currentRegister.unit);
  }

  get formIndex(): FormIndexEntry[] {
    if (this.isUnitAdministrasi) {
      return (this.showIgdShell ? IGD_FORM_INDEX : RALAN_FORM_INDEX).filter(
        e => ADMINISTRASI_TOP_TABS.includes(e.topTab)
      );
    }
    if (this.isInstalasiGizi) return PEMERIKSAAN_GIZI_FORM_INDEX;
    if (this.isUnitRekamMedis) return PEMERIKSAAN_REKAM_MEDIS_FORM_INDEX;
    if (this.isPemeriksaanRingkas) return PEMERIKSAAN_RINGKAS_FORM_INDEX;
    if (this.showIgdShell) return IGD_FORM_INDEX;
    if (this.isUnitHemodialisa) {
      return RALAN_FORM_INDEX.filter(e => e.elemId !== "tab-assesmen");
    }
    return RALAN_FORM_INDEX;
  }

  get isUnitHemodialisa(): boolean {
    return [this.stateuser.unit_id, this.stateuser.unit_group_id].some(kode => isHemodialisa(kode));
  }

  get isPemeriksaanRingkas(): boolean {
    return isPemeriksaanRingkas(this.stateuser.unit_id);
  }

  get isInstalasiGizi(): boolean {
    return isInstalasiGizi(this.stateuser.unit_id);
  }

  get isUnitRekamMedis(): boolean {
    return isUnitRekamMedis(this.stateuser.unit_id);
  }

  get isUnitAdministrasi(): boolean {
    return isUnitAdministrasi(this.stateuser.unit_id);
  }

  get topTabTerbatas(): ReadonlyArray<string> | null {
    if (this.isUnitAdministrasi) return ADMINISTRASI_TOP_TABS;
    if (this.isPemeriksaanRingkas) return PEMERIKSAAN_RINGKAS_TOP_TABS;
    return null;
  }

  get topTabAwal(): string {
    return this.isUnitAdministrasi ? "tab-persetujuan" : "tab-assesmen";
  }

  get episodeRanap(): boolean {
    return isRanap(this.currentRegister ? this.currentRegister.unit : null);
  }

  get showIgdShell(): boolean {
    const seg = userModule.segmentUnitId;
    if (seg) return seg === "01";

    const reg = this.currentRegister;
    return !!(reg && (reg.unit_asal || reg.unit) === "01");
  }
  
  get tabTreeKey(): string {
    return `${this.register}:${userModule.segmentUnitId || ""}`;
  }

  @Watch("currentRegister", { immediate: true, deep: false })
  onRegisterChangeFetchApproval(reg: IfcRegister | null) {
    if (!reg?.no) return;
    // Trigger fetch approval bila kunjungan sudah punya jam keluar (dout).
    const hasDischarge = !!reg.discharge_at;
    const hasDout = !!reg.dout && reg.dout !== "0000-00-00";
    if (hasDischarge || hasDout) {
      revisionAccessModule.fetchActive(reg.no);
    }
  }

  async alertAsesmenAwalRalan() {
    const dt = await DataAsesmenRalan.getDataStatusAsesmenRalan(
      this.stateuser.unit_id,
      this.rm,
      this.register
    );

    if (dt.status == "0") {
      //
    } else if (dt.status == "1") {
      // this.modalOpenKonfirmasi = true;
      // this.msgConfirm = dt.message;
      // this.cat = "asesmen_ralan";
      if (dt.message) {
        this.notifToastMsg = dt.message;
        this.showNotifToast = true;
      }

      this.statusAsesmen = "1";
    } else {
      // this.tab = "tab-assesmen";
      this.tab = "tab-suket";
      // appModule.sendErrorAlert(dt.message);
    }
  }

  async alertRegHf() {
    regHf.default.cekAlert(this.rm).then(resp => {
      if (resp.status == 1) {
        this.modalOpenKonfirmasi = true;
        this.msgConfirm =
          resp.message + " Isi Register Gagal Jantung terlebih dulu?";

        this.cat = "reghf";
      }
    });
  }

  async callDataStore() {
    const paramresume = {
      reg: this.register,
      idUser: this.sess_login.id
    };

    storeSoap.act_soap_on_reg(this.register);
    storeResume.act_resume_on_reg(paramresume);
    storeAssesmenRalan.actAsesmenAwal({
      unit_id: this.stateuser.unit_id,
      reg: this.register,
      profesi: this.stateuser.profesi,
      rm: this.rm
    });

    storePanggilanLayanan.getAllPanggilan(this.register);
    storeCatatanEdukasi.actCatatanEdukasi(this.register);
    // storeAsesmenGigi.actAsesmenGigiByReg(this.register);

    if (!storeDokter.list.length || !storeDokter.listAll.length) {
      storeDokter.act_dokter_all();
    }

    await storePasien.act_pasien_last_reg(this.rm);
    storePasien.getPasienNote(this.rm);

    storeBilling.getDiagnosis(this.register);
    storeBilling.getProcedure(this.register);

    if (!storeReferensiUnit.unit.length) {
      storeReferensiUnit.getUnit();
    }

    if (!storeRefAsesmen.fallriskMFS.length) {
      storeRefAsesmen.getFallriskMFS();
    }

    if (!storeRefAsesmen.fallriskHumDum.length) {
      storeRefAsesmen.getFallriskHumDum();
    }

    if (!storeRefAsesmen.nyeriNIPS.length) {
      storeRefAsesmen.getNyeriNIPS();
    }

    if (!storeRefAsesmen.nyeriFLACC.length) {
      storeRefAsesmen.getNyeriFLACC();
    }

    if (!storeRefAsesmen.nyeriBPS.length) {
      storeRefAsesmen.getNyeriBPS();
    }

    // this.notifPastMonthsLabHistory();
  }

  notifPastMonthsLabHistory() {
    const past3MonthHistory = storeRiwayat.listriwayat.filter(it => {
      return (
        [userModule.user.unit_id, userModule.user.unit_group_id].includes(
          it.unit?.id
        ) &&
        it.keluar >=
          moment()
            .subtract({ days: 90 })
            .format("YYYY-MM-DD")
      );
    });

    if (
      userModule.isMedis &&
      ["27", "10", "12", "17"].includes(userModule.user.unit_group_id) &&
      past3MonthHistory.length > 0
    ) {
      const param = {
        rm: this.rm,
        keluar: moment().format("YYYY-MM-DD"),
        masuk: moment()
          .subtract({ days: 180 })
          .format("YYYY-MM-DD")
      };

      DataPenunjang.getDataListHasilLabByRm(
        param.rm,
        param.masuk,
        param.keluar
      ).then(resp => {
        const offsetDateLabNotif = moment()
          .subtract({ days: 90 })
          .format("YYYY-MM-DD");

        const lab = resp.data.filter(it => it.tgl_order >= offsetDateLabNotif);

        if (!lab.length) {
          alert(
            `Tidak ada pemeriksaan lab yang dilakukan sejak 3 bulan terakhir.`
          );
        }
      });
    }
  }

  stateSoap() {
    storeSoap.act_soap_on_reg(this.register);
  }

  get stateuser() {
    return userModule.user;
  }

  get statesoapdata() {
    return storeSoap.soapAll;
  }

  get stateresume() {
    return storeResume.resume;
  }

  get statepasien() {
    return storePasien.identitasPasien;
  }

  get isDokter() {
    return this.stateuser?.isMedis && this.stateuser.profesi !== "Psikolog";
  }

  showTab(item) {
    // this.tabs=item
    this.tab = item;
    // this.respResumes=item
    // console.log('1resr ',item)
  }

  // Selecting a form in the flying-bar search: switch to the host top tab and
  // push a deep-link payload the target sub-page watches. Nonce lets the same
  // form be re-opened; sub-pages guard on payload.topTab. Rujukan sub-tabs are
  // driven directly here (subTabRujukan) since they live in this page.
  onOpenForm(payload: FormIndexEntry) {
    const topTab =
      this.isUnitAdministrasi &&
      payload.topTab === "tab-suket" &&
      payload.category === "Persetujuan"
        ? "tab-persetujuan"
        : payload.topTab;

    this.deepLink = { ...payload, topTab, nonce: Date.now() };
    this.tab = topTab;
    if (payload.topTab === "tab-konsul" && payload.elemId) {
      this.subTabRujukan = payload.elemId;
    }
  }

  applyQueryDeepLink() {
    const q: any = this.$route.query;
    if (!q || !q.topTab) return;

    const elemId = q.tab ? String(q.tab) : undefined;

    const topTab =
      this.isPemeriksaanRingkas && q.topTab === "tab-rekam-medis"
        ? "tab-assesmen"
        : String(q.topTab);

    this.onOpenForm({
      topTab,
      elemId,
      category: q.category ? String(q.category) : undefined,
      bukaForm: q.bukaForm === "1",
      prefill:
        elemId === "tab-skdp"
          ? ambilPrefillSkdp(this.$route.params.register)
          : null
    } as any);
  }
  showTabRujukan(item) {
    this.modalRujukan = item["modal"];
    this.tab = item["tab"];
  }
  showTabSpri(item) {
    this.modalSpri = item["modal"];
    this.tab = item["tab"];
  }

  getResume() {
    appModule.setLoading(true);

    const dpjp_id = "";
    const dt = DataResume.getDataResume(this.register, dpjp_id);
    dt.then(dt => {
      appModule.setLoading(false);

      const data = dt["data"];
      this.respResumes = data;
    });
  }

  openRightDrawer(v) {
    this.openDrawer = v;
  }

  get showLoading() {
    return appModule.loading;
  }

  klikTabSoap() {
    const param = {
      unit_id: this.stateuser.unit_id,
      reg: this.register,
      profesi: this.stateuser.profesi
    };

    storeSoap.act_soap_on_reg(this.register);
    storeAssesmenRalan.actAsesmenAwal(param);
  }
  klikTabKonsul() {
    storeKonsul.actKonsul_on_reg(this.register);
  }

  asesmenAwal() {
    this.tab = "tab-assesmen";
    this.statusAsesmen = "1";
  }
  get screen() {
    if (this.$vuetify.breakpoint.lgAndDown) return "non";
    else return "default";
  }
  toRegHf() {
    this.tab = "tab-assesmen";
    this.statusAsesmen = "2";
  }

  dialogOnConfirm() {
    if (this.cat === "asesmen_ralan") {
      this.asesmenAwal();
    } else if (this.cat === "reghf") {
      // this.toRegHf();
      this.toRegHf();
    }

    this.cat = "";
  }

  @Watch("tab")
  changeTab(val) {
    if (this.topTabTerbatas && !this.topTabTerbatas.includes(val)) {
      this.tab = this.topTabAwal;
      return;
    }

    this.$nextTick(() => scrollTabIntoView(this.$el));
    if (val == "tab-pelayanan") {
      this.lockRegister();
    } else {
      this.unlockRegister();
    }
  }

  lockRegister() {
    const dt = Billing.lockRegister(
      this.register,
      this.stateuser.id,
      this.stateuser.unit_id,
      "klinik"
    );
    dt.then(dt => {
      // console.log("lock ", dt);
      if (dt.status != 1) {
        this.statusLock = "0";
        appModule.sendErrorAlert(dt.message);
        this.tab = this.topTabAwal;
      } else {
        this.statusLock = "1";
      }
    });
  }
  unlockRegister() {
    const dt = Billing.unlockRegister(
      this.register,
      this.stateuser.id,
      "klinik"
    );
    dt.then(dt => {
      this.statusLock = "0";
      // console.log("unlock ", dt);
      if (dt.status != 1) {
        // appModule.sendErrorAlert(dt.message);
      }
    });
  }

}
